import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../Common/ChartsDynamicColor";
import { getDealStatusForFi } from "http/UAM/userDashboardWidget.helper";
import { startCase } from "lodash";
import PropTypes from 'prop-types';
import NoDataChart from "pages/EntityMoreInformation/NoDataComponent";

const DealStatusAdmin = ({ dataColors, userType }) => {
    const apexsalesAnalyticsChartColors = getChartColorsArray(dataColors);
    const [selectedFilter, setSelectedFilter] = useState("All");
    const [dealStatusData, setDealStatusData] = useState([]);
    const [showStatus, setShowStatus] = useState(true)

    useEffect(() => {
        getDealStatusForFi({ productType: selectedFilter }).then((res) => {
            setDealStatusData(res.data);
            if (res.data['Pending Queries'] == 0 && res.data['interestShownByFI'] == 0 && res.data['totalNoOfDeals'] == 0) {
                setShowStatus(false)
            } else {
                setShowStatus(true)
            }
        });
    }, [selectedFilter, userType]);

    const handleFilterChange = (e) => {
        setSelectedFilter(e.target.value);
    };

    const labels = Object.keys(dealStatusData).filter(
        (key) => key !== "totalNoOfDeals"
    );
    const values = labels.map(label => dealStatusData[label]).filter(value => value !== dealStatusData.totalNoOfDeals);

    const series = values;
    const options = {
        labels: labels.map((i) => startCase(i)),
        colors: apexsalesAnalyticsChartColors,
        legend: { show: false },
        dataLabels: {
            enabled: true,
            formatter: function ({ seriesIndex, w }) {
                return w?.globals?.series[seriesIndex];
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        name: {
                            show: false,
                        },
                        value: {
                            show: false,
                        },
                    },
                    size: "65%",
                },
            },
        },
        tooltip: {
            enabled: true,
            y: {
                show: true,
                formatter: (value) => {
                    return `${value}`;
                },
            },
        },
        annotations: {
            position: "center",
            yaxis: [
                {
                    y: 0,
                    y2: 1,
                    label: {
                        text: "Deal Status",
                        style: {
                            fontSize: "20px",
                            color: "#333",
                            background: "transparent",
                        },
                    },
                },
            ],
        },
    };

    return (
        <Card>
            {showStatus ? <CardBody>
                <Row>
                    <Col lg='6' sm='12'>
                        <h4 className="card-title mb-2">
                            {"Total deals summary"}
                        </h4>
                    </Col>
                    <Col lg='6' sm='12'
                        className="mb-2"
                    >
                        <select
                            className="form-select"
                            id="filterOptions"
                            value={selectedFilter}
                            onChange={handleFilterChange}
                        >
                            <option value="All">All</option>
                            <option value="Working Capital">Working Capital</option>
                            <option value="Term Loan">Term Loan</option>
                            <option value="Others(Lease)">Others(Lease)</option>
                            <option value="Structured Finance">Structured Finance</option>
                        </select>
                    </Col>
                </Row>

                {/* Chart component */}
                <div className="d-flex align-items-center flex-column flex-md-row">
                    <div style={{ position: "relative" }}>
                        <div id="donut-chart-deal-status">
                            <ReactApexChart
                                options={options}
                                series={series}
                                type="donut"
                                height={300}
                                width={350}
                                className="apex-charts"
                            />
                        </div>
                        <div
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                textAlign: "center",
                            }}
                        >
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <span style={{ fontSize: "20px" }}>
                                    {dealStatusData["totalNoOfDeals"]}
                                </span>
                                <span style={{ fontSize: "14px" }}>Total deals summary</span>
                            </div>
                        </div>
                    </div>
                    <Row>
                        {labels.map((label, index) => {
                            return (
                                <Col
                                    key={label}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <i
                                        style={{ color: apexsalesAnalyticsChartColors[index] }}
                                        className={`mdi mdi-circle ${apexsalesAnalyticsChartColors[index]} me-1`}
                                    />
                                    <p
                                        className="mb-2 text-truncate"
                                        title={label}
                                        style={{
                                            width: "200px",
                                            textAlign: "left",
                                            fontSize: "14px",
                                        }}
                                    >
                                        {startCase(label)}
                                    </p>
                                </Col>
                            );
                        })}
                    </Row>

                </div>
            </CardBody>
                : <NoDataChart title='No Information Found' subtitle="We couldn't find the Deal Status" />}
        </Card>
    );
};

DealStatusAdmin.propTypes = {
    dataColors: PropTypes.string.isRequired,
    userType: PropTypes.string.isRequired,
}


export default DealStatusAdmin;
